import formBaseMixin from  '../../../components/form/form-base-mixin.js'

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      fields: {
        billing_bank_packet_source_id: '',
        billing_bank_id: '',
        bank_packet_file: {}
      }
    }
  },
  title: function () {
    return 'Загрузка'
  },
  methods: {
    getAsFormData (fields) {
      const sendForm = new FormData()
      for (let key in fields) {
        sendForm.append(key, fields[key])
      }
      sendForm.set('bank_packet_file', fields.bank_packet_file.file)
      return sendForm
    }
  },
  computed: {
    banks () {
      return this.$store.getters.readUrlEndpoint(
        this.getBanksEndpoint()
      ).data
    },
    sources () {
      return this.$store.getters.readUrlEndpoint(
        this.getSourcesEndpoint()
      ).data
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    const promises = []
    const endpoints = [
      methods.getBanksEndpoint,
      methods.getSourcesEndpoint
    ]

    endpoints.forEach(endpointFunc => {
      let endpoint = endpointFunc(route, fromRoute)
      if (endpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', {endpoint}))
      }
    })

    return promises.length ? Promise.all(promises) : Promise.resolve(true)
  }
}
